import interceptorAxios from './InterceptorAxios';

const servicioLayout = {

  procesar_layout(obj){
        return interceptorAxios.post('layout/procesar_layout.json',obj);
  },
  facturar_layout(obj){
    return interceptorAxios.post('layout/facturar_layout.json',obj);
  }  
}

export default servicioLayout;